import { render, staticRenderFns } from "./CommonUse.vue?vue&type=template&id=50f9f86a&scoped=true&"
import script from "./CommonUse.vue?vue&type=script&lang=js&"
export * from "./CommonUse.vue?vue&type=script&lang=js&"
import style0 from "./CommonUse.vue?vue&type=style&index=0&id=50f9f86a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f9f86a",
  null
  
)

export default component.exports